import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { AssistantStatus } from '../../../constants/assistant.constants';
import { StatusContainer } from '../../AssistantMessageList/styles';
import { LoadingDots } from '../loading-dots';
import { StatusMessage } from './styles';
export const StatusIndicator = ({ status, message, }) => {
    const { t } = useTranslation();
    const getStatusMessage = () => {
        if (message)
            return message;
        switch (status) {
            case AssistantStatus.THINKING:
                return t('assistant|assistant_thinking');
            case AssistantStatus.TOOL_EXECUTING:
                return t('assistant|assistant_tool_executing');
            default:
                return '';
        }
    };
    return ([AssistantStatus.THINKING, AssistantStatus.TOOL_EXECUTING].includes(status) && (_jsxs(StatusContainer, { children: [_jsx(StatusMessage, { children: getStatusMessage() }), _jsx(LoadingDots, {})] })));
};
export default StatusIndicator;
